import { gql } from '@apollo/client';
import { ORDER_ITEM_FRAGMENT, OrderItem } from '../useOrder';
import { ORDER_SUMMARY_FRAGMENT, OrderSummary } from '../useOrderSummary';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';

export type PreviewOrderShippingAddressUpdateMutation = {
  previewOrderShippingAddressUpdate: {
    __typename: 'PreviewOrderShippingAddressUpdatePayload';
    data: OrderSummary[];
    included: OrderItem[];
  };
};

export type PreviewOrderShippingAddressUpdateMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction.ChangeAddress;
      attributes: {
        country_code: string;
        order_state: OrderState.Default;
        selected_address_id: string;
      };
      id: string;
      type: 'order_summary';
    };
  };
};

export const PREVIEW_ORDER_SHIPPING_ADDRESS_UPDATE_MUTATION = gql`
  mutation PreviewOrderShippingAddressUpdateMutation(
    $orderId: String!
    $input: UpdateOrderShippingAddressMutationVariables!
  ) {
    previewOrderShippingAddressUpdate(orderId: $orderId, input: $input)
      @rest(
        type: "PreviewOrderShippingAddressUpdatePayload"
        endpoint: "cart"
        path: "/v3.5/order_summary/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
